<template>
  <div class="">
    <requests-counts/>
    <last6-months-stats/>
    <treatment-time-stats/>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts';
  import counts from "./partials/counts";
  import last6MonthsStats from "./partials/last6MonthsStats";
  import treatmentTimeStats from "./partials/treatmentTimeStats";

  export default {
    components: {VueApexCharts, 'requestsCounts': counts, last6MonthsStats, treatmentTimeStats},
    name: "cc",
    data() {
      return {}
    }
  }
</script>
